import paths from 'redux/paths';
import client from 'helpers/client';
import mvpAuth from "../../../helpers/mvpAuth";
import * as types from "../actionTypes";
import {
    FETCH_ACCEPT_REJECT_SESSION, FETCH_ACCEPT_REJECT_SESSION_FAILED,
    FETCH_CREATE_SESSION,
    FETCH_CREATE_SESSION_FAILED,
    FETCH_CREATE_SESSION_SUCCESS, FETCH_HISTORY_SESSIONS, FETCH_HISTORY_TRANSACTIONS,
    FETCH_REGISTER_SESSION, FETCH_REGISTER_SESSION_FAILED,
    FETCH_REMOVE_SESSION,
    FETCH_REMOVE_SESSION_FAILED,
    FETCH_REMOVE_SESSION_SUCCESS, FETCH_TRACKING_SESSION,
    FETCH_UPDATE_SESSION, FETCH_UPLOAD_FILE, FETCH_UPLOAD_FILE_FAILED, FETCH_VERIFY_JOIN_SESSION,
} from '../actionTypes';

export const getSessions = (params = {}) => async (dispatch) => {
    try {
        const data = await client.sendRequest({
            path: 'mvp/senior-home-sessions',
            method: 'GET',
            params: params,
            headers: mvpAuth.getHeaderForMvp(),
        })
        return { success: true, data };
    } catch (e) {
        return { success: false, error: e.message };
    }
}

export const getMySessions = (params) => async (dispatch) => {
    try {
        const data = await client.sendRequest({
            path: 'mvp/my-session',
            method: 'GET',
            params: params,
            headers: mvpAuth.getHeaderForMvp(),
        })
        return { success: true, data };
    } catch (e) {
        return { success: false, error: e.message };
    }
}

export const getListStatusSession = () => async () => {
  try {
    const data = await client.sendRequest({
      path: 'mvp/list-status-session',
      method: 'GET',
      params: {  },
      headers: mvpAuth.getHeaderForMvp(),
    })
    return { success: true, data: data.data.list };
  } catch (e) {
    return { success: false, error: e.message };
  }
}

export const getMyTopics = (params) => async () => {
  try {
    const data = await client.sendRequest({
      path: 'mvp/my-topic',
      method: 'GET',
      params,
      headers: mvpAuth.getHeaderForMvp(),
    })
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.message };
  }
}


export const getProfileRoleBySession = (params) => () => {
  return client.sendRequest({
    path: 'mvp/user-detail-by-session',
    method: 'POST',
    params: params,
    headers: mvpAuth.getHeaderForMvp(),
  }).then(({ data: response }) => {
    return response;
  }).catch((err) => {
    console.log('error', err);
    return null;
  });
};

export const sendToAiSupportSession = (query, userName, category, conversationId = null, parentMessageId = null) => {
  return client.sendRequest({
    path: '/mvp/setup-device-assistant',
    method: 'POST',
    params: {
      "response_mode": "blocking",
      "user": userName,
      "conversation_id": conversationId,
      "files": [],
      "query": query,
      "inputs": {
        "topic_category": category
      },
      "parent_message_id": parentMessageId
    },
    headers: mvpAuth.getHeaderForMvp(),
  }).then(({ data: response }) => {
    return response;
  }).catch((err) => {
    console.log('error', err);
    return null;
  });
}

export const getDetailSession = (params) => (dispatch) => {
    dispatch({ type: types.FETCH_SESSION_DETAIL });
    return client.sendRequest({
        path: 'mvp/session-detail',
        method: 'GET',
        params: params,
        headers: mvpAuth.getHeaderForMvp(),
    }).then(({ data: response }) => {
        if (params.notAddState) {
            return response;
        }
        dispatch({ type: types.FETCH_SESSION_DETAIL_SUCCESS, data: response });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_SESSION_DETAIL_FAILED, reason: err });
        return null;
    });
};

export const getSeniorDetailSession = async (params) => {
    return client.sendRequest({
        path: 'mvp/senior-senior-detail',
        method: 'GET',
        params: { id: params.id ?? params.sessionId },
        headers: mvpAuth.getHeaderForMvp(),
    }).then(({ data: response }) => {
        if (params.notAddState) {
            return response;
        }
        return response;
    }).catch((err) => {
        return null;
    });
};

export const getSeniorBuddyDetailSession = async (params) => {
    return client.sendRequest({
        path: 'mvp/senior-buddy-detail',
        method: 'GET',
        params: { id: params.id ?? params.sessionId },
        headers: mvpAuth.getHeaderForMvp(),
    }).then(({ data: response }) => {
        if (params.notAddState) {
            return response;
        }
        return response;
    }).catch((err) => {
        return null;
    });
};

export const getDetailTopic = (params) => () => {
  return client.sendRequest({
    path: 'mvp/topic-detail',
    method: 'GET',
    params: params,
    headers: mvpAuth.getHeaderForMvp(),
  }).then(({ data: response }) => {
    return response;
  }).catch((err) => {
    return Promise.reject(err?.message || err?.data?.message || 'Something went wrong');
  });
};

export const verifyJoinSession = (params) => (dispatch) => {
    dispatch({ type: types.FETCH_VERIFY_JOIN_SESSION });
    return client.sendRequest({
        path: 'mvp/join-session',
        method: 'POST',
        params,
        headers: mvpAuth.getHeaderForMvp(),
    }).then(response => {
        dispatch({ type: types.FETCH_VERIFY_JOIN_SESSION_SUCCESS });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_VERIFY_JOIN_SESSION_FAILED, reason: err });
        return null;
    });
};

export const getTokenSession = (params) => (dispatch) => {
    dispatch({ type: types.FETCH_SESSION_TOKEN });
    return client.sendRequest({
        path: 'mvp/gen-token-session',
        method: 'POST',
        params,
        headers: mvpAuth.getHeaderForMvp(),
    }).then(({ data: response }) => {
        dispatch({ type: types.FETCH_SESSION_TOKEN_SUCCESS });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_SESSION_TOKEN_FAILED, reason: err });
        return null;
    });
};

export const getCategorySessions = () => (dispatch) => {
    dispatch({ type: types.FETCH_SESSION_CATEGORIES });
    return client.sendRequest({
        path: 'mvp/list-category',
        method: 'GET',
        headers: mvpAuth.getHeaderForMvp(),
    }).then(({ data: response }) => {
        dispatch({ type: types.FETCH_SESSION_CATEGORIES_SUCCESS });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_SESSION_CATEGORIES_FAILED, reason: err });
        return null;
    });

}

export const createSession = (params) => (dispatch) => {
    dispatch({ type: types.FETCH_CREATE_SESSION });
    let authorization = mvpAuth.getHeaderForMvp()

    return client.sendRequest({
        path: 'mvp/create-session',
        method: 'POST',
        params: params,
        headers: {
            'content-type': 'multipart/form-data',
            'authorization': authorization.authorization
        },
    }).then(({ data: response }) => {
        dispatch({ type: types.FETCH_CREATE_SESSION_SUCCESS });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_CREATE_SESSION_FAILED, reason: err });
        console.log('error', err)
        return err;
    });
}

export const updateSession = (params) => (dispatch) => {
    dispatch({ type: types.FETCH_UPDATE_SESSION });
    let authorization = mvpAuth.getHeaderForMvp()

    return client.sendRequest({
        path: 'mvp/update-session',
        method: 'POST',
        params: params,
        headers: {
            'content-type': 'multipart/form-data',
            'authorization': authorization.authorization
        },
    }).then((response) => {
        dispatch({ type: types.FETCH_UPDATE_SESSION_SUCCESS });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_UPDATE_SESSION_FAILED, reason: err });
        return err;
    });
}

export const removeSession = (params) => (dispatch) => {
    dispatch({ type: types.FETCH_REMOVE_SESSION });
    return client.sendRequest({
        path: 'mvp/delete-session-web/' + params._id,
        method: 'POST',
        params: params,
        headers: mvpAuth.getHeaderForMvp()
    }).then((response) => {
     //   dispatch({ type: types.FETCH_REMOVE_SESSION_SUCCESS, isDeleteSession: true });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_REMOVE_SESSION_FAILED, reason: err });
        return err;
    });
}

export const archiveSession = (params) => (dispatch) => {
  return client.sendRequest({
    path: 'mvp/archive-session',
    method: 'POST',
    params: { id: params.id, isArchive: params.isArchive },
    headers: mvpAuth.getHeaderForMvp()
  }).then((response) => response).catch((err) => err);
};

export const registerSession = (params) => (dispatch) => {
    dispatch({ type: types.FETCH_REGISTER_SESSION });
    return client.sendRequest({
        path: 'mvp/senior-register-session',
        method: 'POST',
        params: params,
        headers: mvpAuth.getHeaderForMvp()
    }).then((response) => {
        //   dispatch({ type: types.FETCH_REGISTER_SESSION_SUCCESS, isDeleteSession: true });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_REGISTER_SESSION_FAILED, reason: err });
        return err;
    });
}


export const uploadFile = (params) => (dispatch) => {
    dispatch({ type: types.FETCH_UPLOAD_FILE });
    let authorization = mvpAuth.getHeaderForMvp()
    return client.sendRequest({
        path: 'mvp/upload-file',
        method: 'POST',
        params: params,
        headers: {
            'content-type': 'multipart/form-data',
            'authorization': authorization.authorization
        },
    }).then((response) => {
        //   dispatch({ type: types.FETCH_UPLOAD_FILE_SUCCESS, isDeleteSession: true });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_UPLOAD_FILE_FAILED, reason: err });
        return err;
    });
}

export const getHistoryUseSessions = () => (dispatch) => {
    dispatch({ type: types.FETCH_HISTORY_SESSIONS });
    return client.sendRequest({
        path: 'mvp/history-use-sessions',
        method: 'GET',
        headers: mvpAuth.getHeaderForMvp(),
    }).then(({ data: response }) => {
        dispatch({ type: types.FETCH_HISTORY_SESSIONS_SUCCESS });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_HISTORY_SESSIONS_FAILED, reason: err });
        return null;
    });
}

export const getHistoryTransactions = () => (dispatch) => {
    dispatch({ type: types.FETCH_HISTORY_TRANSACTIONS });
    return client.sendRequest({
        path: 'mvp/history-transactions',
        method: 'GET',
        headers: mvpAuth.getHeaderForMvp(),
    }).then(({ data: response }) => {
        dispatch({ type: types.FETCH_HISTORY_TRANSACTIONS_SUCCESS });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_HISTORY_TRANSACTIONS_FAILED, reason: err });
        return null;
    });
}

export const trackingSession = (params) => (dispatch) => {
    dispatch({ type: types.FETCH_TRACKING_SESSION });
    return client.sendRequest({
        path: 'mvp/tracking-session',
        method: 'POST',
        params: params,
        headers: mvpAuth.getHeaderForMvp()
    }).then((response) => {
        //   dispatch({ type: types.FETCH_REGISTER_SESSION_SUCCESS, isDeleteSession: true });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_TRACKING_SESSION_FAILED, reason: err });
        return err;
    });
}

export const buddyAcceptOrRejectSession = (params) => (dispatch) => {
    dispatch({ type: types.FETCH_ACCEPT_REJECT_SESSION });
    return client.sendRequest({
        path: 'mvp/buddy-confirm-reject-session',
        method: 'POST',
        params: params,
        headers: mvpAuth.getHeaderForMvp()
    }).then((response) => {
        //   dispatch({ type: types.FETCH_ACCEPT_REJECT_SESSION_SUCCESS, isDeleteSession: true });
        return response;
    }).catch((err) => {
        dispatch({ type: types.FETCH_ACCEPT_REJECT_SESSION_FAILED, reason: err });
        return err;
    });
}
export const getListBuddyRole = () => () => {
  return client.sendRequest({
    path: 'mvp/list-buddy-role',
    method: 'GET',
  }).then(({ data: response }) => {
    return response;
  }).catch((err) => {
    return null;
  });
}

export const getListDurationByLevel = () => () => {
  return client.sendRequest({
    path: 'mvp/list-duration-by-level',
    method: 'GET'
  }).then(({ data: response }) => {
    return response;
  }).catch((err) => {
    return null;
  });
}



export const verifySlotSession = (params) => () => {
  return client.sendRequest({
    path: 'mvp/verify-slot-session',
    method: 'POST',
    params: params,
    headers: mvpAuth.getHeaderForMvp()
  }).then((response) => {
    return response;
  }).catch((err) => {
    return err;
  });
}


export const createOneSlotSession = (params) => () => {
  return client.sendRequest({
    path: 'mvp/create-one-slot-session',
    method: 'POST',
    params: params,
    headers: mvpAuth.getHeaderForMvp()
  }).then((response) => {
    return response;
  }).catch((err) => {
    return err;
  });
}

export const updateOneSlotSession = (params) => () => {
  return client.sendRequest({
    path: 'mvp/update-one-slot-session',
    method: 'POST',
    params: params,
    headers: mvpAuth.getHeaderForMvp()
  }).then((response) => {
    return response;
  }).catch((err) => {
    return err;
  });
}

export const getListTopicRegisterByDay  = (params) => () => {
  return client.sendRequest({
    path: 'mvp/list-topic-register-by-day',
    method: 'POST',
    params: params,
    headers: mvpAuth.getHeaderForMvp(),
  }).then(({ data: response }) => {
    return response;
  }).catch((err) => {
    return null;
  });
};

export const seniorRegisterTopic  = (params) => () => {
  return client.sendRequest({
    path: 'mvp/senior-register-topic',
    method: 'POST',
    params: params,
    headers: mvpAuth.getHeaderForMvp(),
  }).then((response) => {
    console.log('res', response)
    return response;
  }).catch((err) => {
    console.log(err)
    return null;
  });
};

export const seniorDeclineOrAcceptSuccessTopic  = (params) => () => {
    return client.sendRequest({
        path: 'mvp/senior-decline-accept-success-topic',
        method: 'POST',
        params: params,
        headers: mvpAuth.getHeaderForMvp(),
    }).then((response) => {
        console.log('res', response)
        return response;
    }).catch((err) => {
        console.log(err)
        return null;
    });
};

export const reportData = (params) => () => {
  return client.sendRequest({
    path: 'mvp/report-data',
    method: 'POST',
    params,
    headers: mvpAuth.getHeaderForMvp(),
  }).then((response) => {
    return response;
  }).catch((err) => {
    console.log(err)
    return null;
  });
};

export const updateStatusReport = (params) => (dispatch) => {
  dispatch({ type: types.RESUBMIT_SESSION });
  return client.sendRequest({
    path: 'mvp/resubmit-session/' + params._id,
    method: 'POST',
    params: params,
    headers: mvpAuth.getHeaderForMvp()
  }).then((response) => {
    return response;
  }).catch((err) => {
    dispatch({ type: types.RESUBMIT_SESSION_FAILED, reason: err });
    return err;
  });
}
export const getReasonReport = () => () => {
  return client.sendRequest({
    path: 'mvp/list-reason-report',
    method: 'GET',
    headers: mvpAuth.getHeaderForMvp(),
  }).then((response) => {
    return response;
  }).catch((err) => {
    console.log(err)
    return null;
  });
};

export const getDataReport  = (params) => () => {
  return client.sendRequest({
    path: '/mvp/detail-data-report/' + params,
    method: 'GET',
    headers: mvpAuth.getHeaderForMvp(),
  }).then((response) => {
    return response;
  }).catch((err) => {
    console.log(err)
    return null;
  });
};

export const appealDataReport  = (params) => () => {
  return client.sendRequest({
    path: '/mvp/appeal-data-report',
    method: 'POST',
    params: params,
    headers: mvpAuth.getHeaderForMvp(),
  }).then((response) => {
    return response;
  }).catch((err) => {
    console.log(err)
    return null;
  });
};

/**
 * AI check từ khóa nhạy cảm - moderate text (Google Cloud).
 * Chỉ nên gọi từ client khi đang trong phiên Zoom (transcript).
 * API stateless, không yêu cầu session_user.
 */
export const moderateText = (params) => () => {
  return client.sendRequest({
    path: 'mvp/moderate-text',
    method: 'POST',
    params: params,
    headers: mvpAuth.getHeaderForMvp(),
  }).then((response) => response).catch((err) => {
    console.log(err);
    return null;
  });
};

/**
 * Log sự kiện từ khóa nhạy cảm (SAFE_CONFIRMED | ACCIDENTAL_MENTION | end_session).
 * Chỉ được gọi khi đang trong phiên Zoom; backend từ chối nếu session đã kết thúc.
 */
export const logSensitiveKeywordEvent = (params) => () => {
  return client.sendRequest({
    path: 'mvp/log-sensitive-keyword-event',
    method: 'POST',
    params: params,
    headers: mvpAuth.getHeaderForMvp(),
  }).then((response) => response).catch((err) => {
    console.log(err);
    return null;
  });
};

export const fetchSatisfactionOptions = () => () => {
  return client.sendRequest({
    path: 'mvp/list-data-evaluate-session',
    method: 'GET',
    headers: mvpAuth.getHeaderForMvp(),
  }).then(({ data: response }) => {
    return response;
  }).catch((err) => {
    console.log(err);
    return null;
  });
};

export const evaluateSession = (params) => () => {
  return client.sendRequest({
    path: 'mvp/evaluate-session',
    method: 'POST',
    params,
    headers: mvpAuth.getHeaderForMvp(),
  }).then((response) => {
    return response;
  }).catch((err) => {
    console.log(err);
    return null;
  });
};

export const fetchTopicRatings = (topicId) => () => {
  return client.sendRequest({
    path: 'mvp/list-data-evaluate-session-by-topic',
    method: 'GET',
    params: { topicId },
    headers: mvpAuth.getHeaderForMvp(),
  }).then(({ data: response }) => {
    return response;
  }).catch((err) => {
    console.log(err);
    return null;
  });
};

export const fetchBuddyRatings = (params) => () => {
  return client.sendRequest({
    path: 'mvp/user-detail-by-session',
    method: 'POST',
    params: { ...params, role: 'guide' },
    headers: mvpAuth.getHeaderForMvp(),
  }).then(({ data: response }) => {
    return response;
  }).catch((err) => {
    console.log(err);
    return null;
  });
};

export const fetchNeedEvaluateSessions = () => () => {
  return client.sendRequest({
    path: 'mvp/list-session-need-to-evaluate',
    method: 'GET',
    headers: mvpAuth.getHeaderForMvp(),
  }).then(({ data: response }) => {
    return response;
  }).catch((err) => {
    console.log(err);
    return null;
  });
};
